import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'
import type { HomeResponse } from '@/types/miniApp'

export function useHome(enabled: boolean) {
  return useQuery<HomeResponse>({
    queryKey: ['mini-app', 'home'],
    queryFn: async () => (await apiClient.get('/api/mini-app/home')).data,
    enabled,
    staleTime: 30_000,
  })
}
